<template>
  <div class="purchase_out_box">
    <div class="lamps_box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    speed: {//速度
      default: 50,
      type: String | Number
    },
    type: {//横向/竖向
      default: '',
      type: String
    }
  },
  data() {
    return {
      el: null,
      timer: null
    }
  },
  computed:{
    ...mapGetters(['isDirection'])
  },
  methods: {
    lamps() {
      this.el.style.transitionDuration = this.el.offsetWidth / this.speed + 's'
      if (this.isDirection) {
        this.el.style.transform = `translateX(${this.el.offsetWidth}px)`
      } else {
        this.el.style.transform = `translateX(-${this.el.offsetWidth}px)`
      }
    }
  },
  mounted() {
    // console.log(`.purchase_out_box .ul${this.speed}`)
    this.lamps_box = document.querySelector('.lamps_box')
    this.el = document.querySelector(`.purchase_out_box .ul${this.speed}`);
    this.lamps();
    this.timer = setInterval(() => {
    this.el.style.transitionDuration = 0 + 's'
    if(this.isDirection){
      this.el.style.transform =`translateX(-${this.lamps_box.offsetWidth}px)`
    }else{
     this.el.style.transform = `translateX(${this.lamps_box.offsetWidth}px)`
    }
    this.lamps();
    }, this.el.offsetWidth /this.speed*1000)
  },
  destroyed(){
    clearInterval(this.timer)
    this.timer = null;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/variableName";
@import "../../../style/mixin";
.purchase_out_box {
  background: transparent;
  width: 100%;
  min-height: torem(25);
  // height: inherit;
  overflow: hidden;
  position: relative;
}
.lamps_box {
  width: 100%;
  position: absolute;
  // width: auto!important;
  left: 0;
  top: 0;
  // width: 100%;
  // min-width: 100vw;
  display: flex;
  white-space: nowrap;
  // height: torem(25);
  height: 100%;
  ul {
    transition-timing-function: linear;
    transform: translateX(0);
  }
  // overflow: scroll;
}
.trotting-horse-lamp2{
  transition-timing-function: linear;
  transform: translateX(0);
}
</style>



// WEBPACK FOOTER //
// src/view/purchase/compontents/horselamps.vue